import { useTableContext } from '@edge/spark/io-react-table'
import { useActionDrawerWorkflow, closeActionDrawer, openActionDrawer } from './action-drawer.store'
import { ActionDrawerContainer } from './ui-action-drawer'

export const ActiveActionDrawerWrapper = () => {
    const activeWorkflow = useActionDrawerWorkflow()
    const clearActiveRowKey = useTableContext((s) => s.clearActiveRowKey)

    const handleClickAway = () => {
        clearActiveRowKey()
        closeActionDrawer()
    }

    if (!activeWorkflow) return null

    const { drawer: DrawerComponent } = activeWorkflow

    return (
        <ActionDrawerContainer open onClose={handleClickAway} onOpen={openActionDrawer}>
            {typeof DrawerComponent === 'function' ? <DrawerComponent /> : null}
        </ActionDrawerContainer>
    )
}
